import { render, staticRenderFns } from "./HistoriasClinicas.vue?vue&type=template&id=5dba9940&scoped=true"
import script from "./HistoriasClinicas.vue?vue&type=script&lang=js"
export * from "./HistoriasClinicas.vue?vue&type=script&lang=js"
import style0 from "./HistoriasClinicas.vue?vue&type=style&index=0&id=5dba9940&prod&scoped=true&lang=css"
import style1 from "./HistoriasClinicas.vue?vue&type=style&index=1&id=5dba9940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba9940",
  null
  
)

export default component.exports